export default {"src":"/_next/static/media/chrome.bf0f75f6.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};